import { useState } from "react";
import { Layers } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { BACKEND, api, errMsg } from "@/lib/api";
import { CopyBox } from "@/components/pax/PaxPanel";
import { anlopCode } from "@/components/anlop/embedCodes";

export const RegionCard = ({ cid, ports, onPorts }) => {
  const r = ports.region;
  const [title, setTitle] = useState(r.title);
  const save = async (patch) => {
    try {
      const { data } = await api.put(`/customers/${cid}/anlop/region`, { enabled: r.enabled, title, ...patch });
      onPorts(data);
      if ("enabled" in patch) toast.success(patch.enabled ? "Samlelisten er slått på" : "Samlelisten er slått av");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className={`rounded-lg border p-4 sm:p-5 space-y-4 transition-colors ${r.enabled ? "border-sky-300 bg-sky-50/50" : "border-slate-200 bg-white"}`} data-testid="anlop-region-card">
      <div className="flex items-start gap-3">
        <Layers className="w-5 h-5 text-sky-700 mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-medium text-slate-900">Samleliste for regionen</div>
          <p className="text-sm text-slate-500">Én felles anløpsliste med alle havnene, der besøkende kan filtrere på havn. Havnelistene over virker som før.</p>
        </div>
        <Switch checked={r.enabled} onCheckedChange={(v) => save({ enabled: v })} aria-label="Samleliste for regionen" data-testid="anlop-region-switch" />
      </div>
      {r.enabled && (<>
        <label className="space-y-1.5 block sm:max-w-sm">
          <span className="text-sm font-medium text-slate-700">Tittel på samlelisten</span>
          <Input value={title} maxLength={60} onChange={(e) => setTitle(e.target.value)} onBlur={() => title.trim() && title !== r.title && save({})} data-testid="anlop-region-title" />
        </label>
        <p className="text-xs text-slate-500">Farger, tekster og utseende hentes fra den første havnen ({ports.ports[0].name}). Kalender-QR er ikke med i samlelisten.</p>
        <div className="grid lg:grid-cols-2 gap-3">
          <CopyBox label="Samleliste (alle havner)" testId="anlop-region-code-list" text={anlopCode(r.key, "anlop")} />
          <CopyBox label="Neste anløp i regionen (teaser)" testId="anlop-region-code-teaser" text={anlopCode(r.key, "anlop-teaser")} />
        </div>
        <a href={`${BACKEND}/api/anlop/${r.key}/list`} target="_blank" rel="noreferrer" className="text-sm text-sky-700 hover:underline" data-testid="anlop-region-preview">Åpne samlelisten i ny fane</a>
      </>)}
    </div>
  );
};
